import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const clashDetailsSlice = createSlice({
  name: "clashDetails",
  initialState: {},
  reducers: {
    setClashDetails: (_state: any, action: PayloadAction<any>) => ({ ...action.payload }),
    setClashSettings: (_state: any, action: PayloadAction<any>) => ({
      ..._state,
      settings: { ..._state?.settings, ...action.payload },
    }),
  },
});

export const { setClashDetails, setClashSettings } = clashDetailsSlice.actions;

export const clashDetails = clashDetailsSlice.reducer;

export default {
  clashDetails,
};
